export const CODE_LITE_COOKIE_PREFIX = 'sso_core_';
